<template>
  <div>
    <component
      :is="
        cardType == 1
          ? LazyExperienceCard
          : cardType == 2
            ? LazyExperienceCardTwo
            : cardType == 3
              ? LazyExperienceCardThree
              : cardType == 4
                ? LazyExperienceCardFour
                : cardType == 5
                  ? LazyExperienceCardFive
                  : cardType == 6
                    ? LazyExperienceCardSix
                    : cardType == 7
                      ? LazyExperienceCardSeven
                      : cardType == 8 || cardType == 9
                        ? LazyExperienceCardEight
                        : LazyExperienceCard
      "
      :id="item?.id"
      :key="item?.id"
      :image="item?.photo_url ?? item?.thumbnail"
      :cities="item?.cities"
      :title="item?.title"
      :categories="item?.categories"
      :rate="item?.rating"
      :market-price="item?.market_price?.amount || 0"
      :price="item?.starting_price?.amount || 0"
      :currency="item?.starting_price?.currency.code || '-'"
      :is-negotiable="item?.is_negotiable"
      :has-pay-later="item?.payment_options?.cash_payment"
      :slug="item?.slug"
      :has-border="hasBorder"
      :discount-colors="discountColors"
      :vertical="vertical"
      :short-description="item?.short_description"
      class="w-full"
      :class="[
        { 'md:!border-0': cardType === 4 },
        { 'md:!border-0 h-[399px] md:h-[460px]': cardType === 5 },
        { 'md:!border-0 h-[460px]': cardType === 6 },
        { 'md:!border-0': cardType === 7 },
        { 'dark-mode': darkMode },
      ]"
      :custom-class="customClass"
      :to-path="productRoute(item)"
      :titleClass="titleClass"
    />
  </div>
</template>
<script setup lang="ts">
import { type PropType, defineAsyncComponent } from "vue";
import type { IProduct } from "../../types/general";

const LazyExperienceCard = defineAsyncComponent(
  () => import("./ExperienceCard.vue")
);
const LazyExperienceCardTwo = defineAsyncComponent(
  () => import("./ExperienceCardTwo.vue")
);
const LazyExperienceCardThree = defineAsyncComponent(
  () => import("./ExperienceCardThree.vue")
);
const LazyExperienceCardFour = defineAsyncComponent(
  () => import("./ExperienceCardFour.vue")
);
const LazyExperienceCardFive = defineAsyncComponent(
  () => import("./ExperienceCardFive.vue")
);
const LazyExperienceCardSix = defineAsyncComponent(
  () => import("./ExperienceCardSix.vue")
);
const LazyExperienceCardSeven = defineAsyncComponent(
  () => import("./ExperienceCardSeven.vue")
);
const LazyExperienceCardEight = defineAsyncComponent(
  () => import("./ExperienceCardEight.vue")
);

const props = defineProps({
  cardType: { type: Number, default: 1 },
  customClass: {
    type: String,
    default: "bg-white",
  },
  item: {
    type: Object as PropType<IProduct>,
    required: true,
  },
  hasBorder: { type: Boolean, default: false },
  darkMode: { type: Boolean, default: false },
  discountColors: {
    type: String,
    default: "bg-discount-background text-primary-1",
  },
  vertical: { type: Boolean, default: false },
  titleClass: { type: String, default: null },
});
const config = useRuntimeConfig();
const layout = config.public.layout;
const localePath = useLocalePath();
function productRoute(item: IProduct) {
  if (layout.type.includes("supplier")) {
    return localePath(`/experiences/${item?.slug}`);
  } else {
    return localePath(`/things-to-do-in-${item.cities[0]?.slug}/${item?.slug}`);
  }
}
// const selectedComponent = computed(() => {
//   switch (props.cardType) {
//     case 1:
//       return LazyExperienceCard;
//     case 2:
//       return LazyExperienceCardTwo;
//     case 3:
//       return LazyExperienceCardThree;
//     case 4:
//       return LazyExperienceCardFour;
//     case 5:
//       return LazyExperienceCardFive;
//     case 6:
//       return LazyExperienceCardSix;
//     case 7:
//       return LazyExperienceCardSeven;
//     case 8:
//       return LazyExperienceCardEight;
//     default:
//       return LazyExperienceCard; // Default to ExperienceCard if no match
//   }
// });
</script>
